// Import createPinia
import { createPinia } from "pinia";

// Export stores
export * from "./auth";
export * from "./club";

// Export pinia instance
export default createPinia();
